const FAQHyfye = () => {
  return (
  <section id="faq" className="bg_light_dark">
    <div className="container">
      <div className="row">
        <div className="col-lg-8 col-md-12 offset-lg-2">
          <div className="text-center faq-header">
            <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">Frequently Asked Questions</h4>
            <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
              Everything you need to know about Hyfye, your gateway to a universal economy of appreciation.
            </p>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-lg-12">
          <div id="accordion" className="faq_content2">

            {/* 1 */}
            <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.4s">
              <div className="card-header" id="headingOne">
                <h6 className="mb-0">
                  <a data-toggle="collapse" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    What is Hyfye?
                  </a>
                </h6>
              </div>
              <div id="collapseOne" className="collapse show" data-parent="#accordion">
                <div className="card-body">
                  Hyfye (HYE) is the world's first universal tip coin — designed to let users tip, earn, buy, sell, and participate in a global decentralized economy.
                </div>
              </div>
            </div>

            {/* 2 */}
            <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.5s">
              <div className="card-header" id="headingTwo">
                <h6 className="mb-0">
                  <a className="collapsed" data-toggle="collapse" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    How do I buy Hyfye (HYE) tokens?
                  </a>
                </h6>
              </div>
              <div id="collapseTwo" className="collapse" data-parent="#accordion">
                <div className="card-body">
                  You can buy HYE tokens during the presale on PinkSale using BNB or USDT (BEP-20). After launch, HYE will also be listed on exchanges for easy purchase.
                </div>
              </div>
            </div>

            {/* 3 */}
            <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.6s">
              <div className="card-header" id="headingThree">
                <h6 className="mb-0">
                  <a className="collapsed" data-toggle="collapse" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Where can I store HYE tokens safely?
                  </a>
                </h6>
              </div>
              <div id="collapseThree" className="collapse" data-parent="#accordion">
                <div className="card-body">
                  You can store Hyfye (HYE) in any BEP-20 compatible wallet such as MetaMask, Trust Wallet, or SafePal.
                </div>
              </div>
            </div>

            {/* 4 */}
            <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.7s">
              <div className="card-header" id="headingFour">
                <h6 className="mb-0">
                  <a className="collapsed" data-toggle="collapse" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    What makes Hyfye unique?
                  </a>
                </h6>
              </div>
              <div id="collapseFour" className="collapse" data-parent="#accordion">
                <div className="card-body">
                  Unlike traditional cryptocurrencies, Hyfye focuses on tipping, rewarding, and recognizing contributions instantly across both online and offline worlds.
                </div>
              </div>
            </div>

            {/* 5 */}
            <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.8s">
              <div className="card-header" id="headingFive">
                <h6 className="mb-0">
                  <a className="collapsed" data-toggle="collapse" href="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    How does tipping work with Hyfye?
                  </a>
                </h6>
              </div>
              <div id="collapseFive" className="collapse" data-parent="#accordion">
                <div className="card-body">
                  Through QR codes, usernames, or simple payment links, users can tip service providers, creators, businesses, or anyone with just a few clicks — powered by HYE tokens.
                </div>
              </div>
            </div>

            {/* 6 */}
            <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.9s">
              <div className="card-header" id="headingSix">
                <h6 className="mb-0">
                  <a className="collapsed" data-toggle="collapse" href="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    Is Hyfye a decentralized project?
                  </a>
                </h6>
              </div>
              <div id="collapseSix" className="collapse" data-parent="#accordion">
                <div className="card-body">
                  Yes, Hyfye runs on a decentralized blockchain model, giving full transparency, community governance, and future quantum-grade security without central authorities.
                </div>
              </div>
            </div>

            {/* 7 */}
            <div className="card animation" data-animation="fadeInUp" data-animation-delay="1.0s">
              <div className="card-header" id="headingSeven">
                <h6 className="mb-0">
                  <a className="collapsed" data-toggle="collapse" href="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                    Can I earn Hyfye without investing?
                  </a>
                </h6>
              </div>
              <div id="collapseSeven" className="collapse" data-parent="#accordion">
                <div className="card-body">
                  Yes! By simply engaging on the Hyfye platform — liking, commenting, posting content, providing services — you can earn HYE tips from the community.
                </div>
              </div>
            </div>

            {/* 8 */}
            <div className="card animation" data-animation="fadeInUp" data-animation-delay="1.1s">
              <div className="card-header" id="headingEight">
                <h6 className="mb-0">
                  <a className="collapsed" data-toggle="collapse" href="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                    What is the future plan for Hyfye?
                  </a>
                </h6>
              </div>
              <div id="collapseEight" className="collapse" data-parent="#accordion">
                <div className="card-body">
                  After token launch, we are building a full decentralized marketplace platform where users can earn, shop, trade services, advertise, and run businesses — all powered by Hyfye.
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default FAQHyfye;
